import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form",
    "gradeInput",
    "previewSection",
    "previewContent",
    "submitBtn"
  ]

  // thresholds configuráveis via data-attributes
  static values = {
    min: { type: Number, default: 0 },
    goodThreshold: { type: Number, default: 7 },
    averageThreshold: { type: Number, default: 5 }
  }

  connect() {
    // Render inicial do preview (caso já existam valores)
    this.updatePreview()
  }

  // === UI ===
  updatePreview() {
    let hasGrades = false
    let html = '<div class="row">'

    this.gradeInputTargets.forEach((input) => {
      const value = (input.value || "").trim()
      if (value !== "") {
        hasGrades = true
        const card = input.closest(".grade-card")
        const subjectName = card?.querySelector(".subject-info h5")?.textContent?.trim() || "Subject"
        const cls = this.getGradeClass(parseFloat(value))
        html += `
          <div class="col-md-6 col-lg-4 mb-3">
            <div class="preview-grade-item">
              <h6 class="text-white font-weight-bold mb-1">${subjectName}</h6>
              <span class="grade-badge ${cls}">${value}</span>
            </div>
          </div>
        `
      }
    })

    html += "</div>"

    if (hasGrades) {
      this.previewContentTarget.innerHTML = html
      this.previewSectionTarget.style.display = "block"
    } else {
      this.previewSectionTarget.style.display = "none"
      this.previewContentTarget.innerHTML = ""
    }
  }

  getGradeClass(score) {
    if (isNaN(score)) return "poor"
    if (score >= this.goodThresholdValue) return "good"
    if (score >= this.averageThresholdValue) return "average"
    return "poor"
  }

  // === Validação ===
  validate(event) {
    // Pelo menos uma nota preenchida e dentro do range [min..max]
    let hasAtLeastOne = false

    for (const input of this.gradeInputTargets) {
      const raw = (input.value || "").trim()
      if (raw === "") continue

      hasAtLeastOne = true
      const score = parseFloat(raw)
      if (isNaN(score) || score < this.minValue) {
        event.preventDefault()
        alert(`As notas deve ser maior que ${this.minValue}.`)
        input.focus()
        return
      }
    }

    if (!hasAtLeastOne) {
      event.preventDefault()
      alert("Você deve preencher pelo menos uma nota para participar.")
    }
  }
}
